@if (errorMessage) {
    <div class="error" data-testid="error-message">
        {{ errorMessage }}
    </div>
}
<form [formGroup]="addArticleForm" id="addArticle_form" (ngSubmit)="onSubmit()" novalidate>
    @for (field of fields; track field) {
        @if (field.type === 'text-input') {
            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                <mat-label>{{ field.display_text }}</mat-label>
                <input
                    type="text"
                    [required]="field.required"
                    [formControlName]="field.name"
                    (change)="onChange(field.name)"
                    (keyup)="onChange(field.name)"
                    matInput
                    [attr.data-testid]="field.name"
                />
                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-required--error'">
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-invalid--error'">
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </mat-form-field>
        }
        @if (field.type === 'radio-button') {
            <div class="form-group">
                <label
                    >{{ field.display_text }}
                    @if (field.required) {
                        <span class="red"> * </span>
                    }
                </label>

                <div class="radio-wrapper">
                    <mat-radio-group
                        aria-labelledby="example-radio-group-label"
                        class="example-radio-group"
                        [formControlName]="field.name"
                        (change)="onChange(field.name)"
                        (keyup)="onChange(field.name)"
                        [attr.data-testid]="field.name"
                    >
                        @for (option of field.options; track option) {
                            <mat-radio-button
                                class="example-radio-button provider"
                                [value]="option.value"
                                [attr.data-testid]="option.value"
                            >
                                {{ option.name }}
                            </mat-radio-button>
                        }
                    </mat-radio-group>
                </div>

                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: addArticleForm.controls[field.name].hasError('required') }"
                        [attr.data-testid]="field.name + '-required--error'"
                    >
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: true }"
                        [attr.data-testid]="field.name + '-invalid--error'"
                    >
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </div>
        }
        @if (field.type === 'date-selector') {
            <mat-form-field class="form-group app-mat-form-field form_group_date" appearance="outline">
                <mat-label>{{ field.display_text }}</mat-label>

                <input
                    type="text"
                    [matDatepicker]="picker"
                    [formControlName]="field.name"
                    (change)="onChange(field.name)"
                    (keyup)="onChange(field.name)"
                    [required]="field.required"
                    matInput
                    [attr.data-testid]="field.name"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>

                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-required--error'">
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-invalid--error'">
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </mat-form-field>
        }
        @if (field.type === 'formatted-text-input') {
            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                <mat-label>{{ field.display_text }}</mat-label>
                <textarea
                    type="text"
                    rows="5"
                    [formControlName]="field.name"
                    (change)="onChange(field.name)"
                    (keyup)="onChange(field.name)"
                    matInput
                    [attr.data-testid]="field.name"
                ></textarea>

                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-required--error'">
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-invalid--error'">
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </mat-form-field>
        }
        @if (field.type === 'checkbox') {
            <div class="form-group form_group_checkbox">
                <mat-checkbox
                    class="btn_checkbox"
                    labelPosition="before"
                    [formControlName]="field.name"
                    (change)="onChange(field.name)"
                    (keyup)="onChange(field.name)"
                    [attr.data-testid]="field.name"
                    >{{ field.display_text }}
                    @if (field.required) {
                        <span class="red"> * </span>
                    }
                </mat-checkbox>
                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: addArticleForm.controls[field.name].hasError('required') }"
                        [attr.data-testid]="field.name + '-required--error'"
                    >
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: true }"
                        [attr.data-testid]="field.name + '-invalid--error'"
                    >
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </div>
        }
        @if (field.type === 'number') {
            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                <mat-label>{{ field.display_text }}</mat-label>
                <input
                    type="number"
                    [name]="field.name"
                    [formControlName]="field.name"
                    (change)="onChange(field.name)"
                    (keyup)="onChange(field.name)"
                    [required]="field.required"
                    matInput
                    [attr.data-testid]="field.name"
                />
                @if (
                    (addArticleForm.controls[field.name].dirty || addArticleForm.controls[field.name].touched) &&
                    addArticleForm.invalid &&
                    addArticleForm.controls[field.name].hasError('required')
                ) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-required--error'">
                        {{ field.display_text }} is required
                    </mat-error>
                }
                @if (formValidationErrors && formValidationErrors[field.name]) {
                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-invalid--error'">
                        {{ formValidationErrors[field.name] }}
                    </mat-error>
                }
            </mat-form-field>
        }
        @if (field.type === 'upload-image') {
            <div class="form-group">
                <label
                    >{{ field.display_text }}
                    @if (field.required) {
                        <span class="red"> * </span>
                    }
                </label>

                <app-multiple-image-uploader
                    [images]="postImages"
                    #imageUpload
                    (imageupload)="onChange('images')"
                ></app-multiple-image-uploader>

                @if (formValidationErrors && formValidationErrors['images'] && formValidationErrors['images'][0]) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: true }"
                        [attr.data-testid]="field.name + '-invalid--error'"
                    >
                        @for (error of formValidationErrors['images'][0]; track error; let x = $index) {
                            {{ error }}
                        }
                    </mat-error>
                }
            </div>
        }
        @if (field.type === 'upload-single-image') {
            <div class="form-group">
                <label
                    >{{ field.display_text }}
                    @if (field.required) {
                        <span class="red"> * </span>
                    }
                </label>
                <app-image-uploader
                    defaultText="Select image"
                    (imageupload)="setScreenshotSrc($event); onChange('screenshot')"
                    [imageLoaded]="!!screenshot"
                    [imageSrc]="screenshot"
                ></app-image-uploader>

                @if (formValidationErrors && formValidationErrors['screenshot']) {
                    <mat-error
                        class="error-msg"
                        [ngClass]="{ fadeIn: true }"
                        [attr.data-testid]="field.name + '-invalid--error'"
                    >
                        @for (error of formValidationErrors['screenshot']; track error; let x = $index) {
                            {{ error }}
                        }
                    </mat-error>
                }
            </div>
        }
        @if (field.type === 'host-names-field') {
            <div>
                @for (item of addArticleForm.controls[field.name]['controls']; track item; let i = $index) {
                    <div [formArrayName]="field.name" [attr.data-testid]="field.name">
                        <div class="host_names_form" [formGroupName]="i">
                            <div class="field-block">
                                @if (field.fields[0].type === 'radio-button') {
                                    <div class="form-group">
                                        <label
                                            >{{ field.fields[0].display_text }}
                                            @if (field.required) {
                                                <span class="red"> * </span>
                                            }
                                        </label>

                                        <div class="radio-wrapper">
                                            <mat-radio-group
                                                aria-labelledby="example-radio-group-label"
                                                class="example-radio-group"
                                                [formControlName]="field.fields[0].name"
                                                [attr.data-testid]="field.fields[0].name"
                                            >
                                                @for (option of field.fields[0].options; track option) {
                                                    <mat-radio-button
                                                        class="example-radio-button provider"
                                                        [value]="option.value"
                                                        [attr.data-testid]="option.value"
                                                    >
                                                        {{ option.name }}
                                                    </mat-radio-button>
                                                }
                                            </mat-radio-group>
                                        </div>

                                        @if (
                                            formValidationErrors &&
                                            formValidationErrors[field.name] &&
                                            formValidationErrors[field.name][i] &&
                                            formValidationErrors[field.name][i][field.fields[0].name]
                                        ) {
                                            <mat-error
                                                class="error-msg"
                                                [ngClass]="{ fadeIn: true }"
                                                [attr.data-testid]="field.name + '-invalid--error'"
                                            >
                                                @for (
                                                    error of formValidationErrors[field.name][i][field.fields[0].name];
                                                    track error
                                                ) {
                                                    {{ error }}
                                                }
                                            </mat-error>
                                        }
                                    </div>
                                }
                            </div>

                            <mat-form-field class="form-group app-mat-form-field" appearance="outline">
                                <mat-label>{{ field.fields[1].display_text }}</mat-label>

                                <input
                                    type="text"
                                    name="name"
                                    [formControlName]="field.fields[1].name"
                                    (change)="onHostNameChanges(i, field.name, field.fields[1].name)"
                                    [required]="field.required"
                                    matInput
                                    [attr.data-testid]="field.name"
                                />
                                @if (
                                    formValidationErrors &&
                                    formValidationErrors[field.name] &&
                                    formValidationErrors[field.name][i] &&
                                    formValidationErrors[field.name][i][field.fields[1].name]
                                ) {
                                    <mat-error class="error-msg" [attr.data-testid]="field.name + '-invalid--error'">
                                        @for (
                                            error of formValidationErrors[field.name][i][field.fields[1].name];
                                            track error
                                        ) {
                                            {{ error }}
                                        }
                                    </mat-error>
                                }
                            </mat-form-field>

                            <button
                                mat-icon-button
                                class="button_delete_item"
                                (click)="deleteHostName(i, field.name)"
                                [attr.data-testid]="field.name + '-delete'"
                            >
                                <mat-icon><i class="fal fa-times"></i></mat-icon>
                            </button>
                        </div>
                    </div>
                }
                <button
                    type="button"
                    class="btn add-button"
                    (click)="addHostName(field.name)"
                    [attr.data-testid]="field.name + '-add'"
                >
                    {{ field.button }}
                </button>
            </div>
        }
    }
    @if (showTags) {
        <div class="form-group">
            <div class="form-group tags_container">
                <app-tags
                    class="tags-tab"
                    [readOnlyMode]="true"
                    [selectedTags]="selectedTags"
                    (toggleTag)="onToggleItem($event)"
                    (selectTags)="onSelectItems($event)"
                    (unSelectTags)="onUnSelectItems($event)"
                ></app-tags>
            </div>

            @if (formValidationErrors && formValidationErrors['tags']) {
                <mat-error class="error-msg" [ngClass]="{ fadeIn: true }" [attr.data-testid]="'tags--error'">
                    {{ formValidationErrors['tags'] }}
                </mat-error>
            }
        </div>
    }

    <div class="form_btns">
        <button class="cancel-button btn" type="button" mat-flat-button (click)="close()" data-testid="cancel">
            Cancel
        </button>

        <app-submit-button-tooltip
            [type]="addArticleForm.invalid || isSubmitting ? 'button' : 'submit'"
            [form]="addArticleForm"
            [isSubmitting]="isSubmitting"
            [buttonText]="edit ? 'Save' : 'Add'"
            [nativeElement]="el.nativeElement"
            dataTestid="add"
        ></app-submit-button-tooltip>
    </div>
</form>
